import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { HeaderComponent } from "../shared/components/header/header.component";
import { LoaderComponent } from "../shared/components/widgets/loader/loader.component";
import { RouterModule } from "@angular/router";
import { LoadingBarRouterModule } from "@ngx-loading-bar/router";
import { FooterComponent } from "../ui/footer/footer.component";
import { CookieConsentComponent } from "../shared/components/cookie-consent/cookie-consent.component";

@Component({
    standalone: true,
    selector: "app-layout",
    templateUrl: "./layout.component.html",
    styleUrls: ["./layout.component.scss"],
    imports: [
        CommonModule,
        HeaderComponent,
        LoaderComponent,
        RouterModule,
        LoadingBarRouterModule,
        FooterComponent,
        CookieConsentComponent
    ]
})
export class LayoutComponent {}

